const CriterioList = () => import("~/components/Views/Prova/Criterio/List");
const CriterioNew = () => import("~/components/Views/Prova/Criterio/New");

import auth from "~/middleware/auth";
import grupoVerify from "~/middleware/grupoVerify";
import perfilVerify from "~/middleware/perfilVerify";

const breadcrumb = [
  { name: "Integrado", link: "http://on.grupointegrado.br/" },
  { name: "Prova", link: "" },
  { name: "Configurações", link: "" }
];

export const criterio = [
  {
    path: "configuracoes/criterio",
    component: CriterioList,
    name: "Critério",
    meta: {
      title: "Critério",
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "configuracoes/criterio/new",
    component: CriterioNew,
    name: "Novo Critério",
    meta: {
      title: "Novo Critério",
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "configuracoes/criterio/:id",
    component: CriterioNew,
    name: "Alterar Critério",
    meta: {
      title: "Alterar Critério",
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  }
];



// WEBPACK FOOTER //
// ./src/routes/prova/configuracao/criterio.js